/**
 * 将接口返回的文件路径转为浏览器可加载的完整 URL。
 * 相对路径（如 /storage/...）拼 VUE_APP_IMG_BASE_URL；
 * 接口若返回带 API 域名的绝对 URL（如 http://127.0.0.1:801/storage/...），同样提取 /storage/ 路径后改拼 CDN。
 */

const DEFAULT_IMG_CDN = 'https://tyjspt.oss-cn-beijing.aliyuncs.com';

function getImgBaseUrl() {
  const fromEnv = (process.env.VUE_APP_IMG_BASE_URL || '').replace(/\/$/, '');
  return fromEnv || DEFAULT_IMG_CDN;
}

/** 从相对或绝对 URL 中提取 /storage/... 资源路径 */
export function extractStoragePath(path) {
  const p = String(path || '')
    .trim()
    .replace(/\\/g, '/');
  if (!p) return '';
  if (p.startsWith('/storage/')) return p;
  const m = p.match(/^(?:https?:)?\/\/[^/?#]+(\/storage\/.*)$/i);
  return m && m[1] ? m[1] : '';
}

export function resolveFileViewUrl(path) {
  if (path == null || typeof path !== 'string') return '';
  let p = path.trim().replace(/\\/g, '/');
  if (!p) return '';
  if (p.startsWith('data:')) return p;

  const base = getImgBaseUrl();
  const storagePath = extractStoragePath(p);
  if (storagePath && base) {
    return `${base}${storagePath}`;
  }

  if (/^https?:\/\//i.test(p)) return p;
  if (p.startsWith('//')) {
    return typeof window !== 'undefined' ? `${window.location.protocol}${p}` : `https:${p}`;
  }

  if (base) {
    const pathPart = p.startsWith('/') ? p : `/${p}`;
    return `${base}${pathPart}`;
  }
  return p.startsWith('/') ? p : `/${p}`;
}
